export default __webpack_public_path__ + "static/media/phone_l.7648f253.png";